module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-item"
  }, [_c('div', {
    staticClass: "item-img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openNewsDetail(_vm.msg.newsId)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.msg.image),
      expression: "msg.image"
    }],
    attrs: {
      "alt": _vm.msg.newsTitle
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-brief"
  }, [_c('div', {
    staticClass: "news-title",
    domProps: {
      "innerHTML": _vm._s(_vm.msg.newsTitle)
    }
  }, [_vm._v(_vm._s(_vm.msg.newsTitle))]), _vm._v(" "), _c('div', {
    staticClass: "news-sub-title"
  }, [_vm._v(_vm._s(_vm.msg.newsSubTitle))]), _vm._v(" "), _c('div', {
    staticClass: "news-sub-time"
  }, [_vm._v("\n      " + _vm._s(_vm.msg.newsTime) + "\n      "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.openNewsDetail(_vm.msg.newsId)
      }
    }
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "阅读更多"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df5f45c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newsItem.vue
// module id = 621
// module chunks = 0